"use strict";

exports.__esModule = true;
exports.ScheduleFormBody = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _reactRouterDom = require("react-router-dom");
var _ScheduleNameField = require("./ScheduleNameField");
var _ScheduleStartTimeField = require("./ScheduleStartTimeField");
var _ScheduleWorkdayOffsetField = require("./ScheduleWorkdayOffsetField");
var _ScheduleAgendasField = require("./ScheduleAgendasField");
var _Core = require("../../Core");
var _reactIntl = require("react-intl");
var _UI = require("../../../Utils/UI");
var _class;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Shows a form which can edit a schedule.
 */
var ScheduleFormBody = exports.ScheduleFormBody = (0, _Core.withTranslator)(_class = /*#__PURE__*/function (_Component) {
  function ScheduleFormBody() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      selectedAgendaID: _this.props.values.agendas.length > 0 ? _this.props.values.agendas[0].id : undefined,
      selectedEventConfigID: undefined,
      selectedTabId: "details",
      isRedirect: false
    };
    _this.handleSelectEventConfig = function (selectedEventConfigID) {
      _this.setState({
        selectedEventConfigID: selectedEventConfigID
      });
    };
    _this.handleSelectAgenda = function (selectedAgendaID) {
      _this.setState({
        selectedAgendaID: selectedAgendaID,
        selectedEventConfigID: undefined
      });
    };
    _this.confirmNavigate = function (e) {
      var _this$props = _this.props,
        form = _this$props.form,
        translate = _this$props.translator.translate;
      if (form.getState().dirty) {
        (0, _UI.showWarningToaster)(translate("ScheduleFormBody.confirmNavigate.text", "Are you sure you want to discard your changes?"), {
          onClick: function onClick() {
            _this.setState({
              isRedirect: true
            });
            e.preventDefault();
          },
          text: translate("ScheduleFormBody.confirmNavigate.button", "Yes")
        });
      } else {
        _this.setState({
          isRedirect: true
        });
        e.preventDefault();
      }
    };
    _this.handleCreateAgenda = function (value) {
      var form = _this.props.form;
      var agenda = value.id ? value : Object.assign({}, value, {
        id: Math.random().toString(16)
      });
      form.mutators.push("agendas", agenda);
      _this.setState({
        selectedAgendaID: agenda.id,
        selectedEventConfigID: undefined
      });
    };
    _this.handleDeleteAgenda = function () {
      var _this$props2 = _this.props,
        form = _this$props2.form,
        values = _this$props2.values,
        translate = _this$props2.translator.translate;
      var selectedAgendaID = _this.state.selectedAgendaID;
      var index = values.agendas.findIndex(function (item) {
        return item.id === selectedAgendaID;
      });
      if (index === -1) {
        return;
      }
      var agenda = values.agendas[index];
      if (agenda.devices.length === 0) {
        var plantAgendas = values.agendas.filter(function (item) {
          return item.devices.length === 0;
        });
        if (plantAgendas.length < 2) {
          (0, _UI.showErrorToaster)(translate("ScheduleFormBody.deleteAgendaError.text", "Cannot delete a plant level agenda."));
          return;
        }
      }
      form.mutators.remove("agendas", index);
    };
    _this.handleCreateEventConfig = function (value) {
      var _this$props3 = _this.props,
        form = _this$props3.form,
        values = _this$props3.values;
      var config = value.id ? value : Object.assign({}, value, {
        id: Math.random().toString(16)
      });
      var selectedAgendaID = _this.state.selectedAgendaID;
      var agenda = values.agendas.find(function (item) {
        return item.id === selectedAgendaID;
      });
      if (!agenda) {
        console.warn("Could not find relevant agenda for selection");
        return;
      }
      var agendaIndex = values.agendas.indexOf(agenda);
      form.mutators.push("agendas[" + agendaIndex + "].eventConfigs", config);
      _this.setState({
        selectedAgendaID: agenda.id,
        selectedEventConfigID: config.id
      });
    };
    _this.handleTabChange = function (selectedTabId) {
      return _this.setState({
        selectedTabId: selectedTabId
      });
    };
    return _this;
  }
  _inheritsLoose(ScheduleFormBody, _Component);
  var _proto = ScheduleFormBody.prototype;
  _proto.render = function render() {
    var _this$props4 = this.props,
      calendarConfig = _this$props4.calendarConfig,
      translate = _this$props4.translator.translate,
      handleSubmit = _this$props4.handleSubmit,
      invalid = _this$props4.invalid,
      form = _this$props4.form,
      values = _this$props4.values;
    var _this$state = this.state,
      selectedTabId = _this$state.selectedTabId,
      isRedirect = _this$state.isRedirect;
    if (isRedirect == true) {
      return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Navigate, {
        to: "/calendar",
        replace: true
      });
    }
    return /*#__PURE__*/_react["default"].createElement("form", {
      onSubmit: handleSubmit,
      style: {
        overflow: "auto"
      }
    }, /*#__PURE__*/_react["default"].createElement(_Core.Toolbar, null, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/_react["default"].createElement(_core.Tabs, {
      id: "ScheduleEditorTabs",
      selectedTabId: selectedTabId,
      onChange: this.handleTabChange
    }, /*#__PURE__*/_react["default"].createElement(_core.Tab, {
      id: "details",
      title: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "Calendar.ScheduleForm.Tabs.Details",
        defaultMessage: "Details"
      }),
      disabled: invalid
    }), /*#__PURE__*/_react["default"].createElement(_core.Tab, {
      id: "agendas",
      title: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "Calendar.ScheduleForm.Tabs.Agendas",
        defaultMessage: "Agendas"
      }),
      disabled: invalid
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: _core.Classes.FLEX_EXPANDER
    }), /*#__PURE__*/_react["default"].createElement(_core.ButtonGroup, {
      style: {
        marginLeft: "1rem"
      }
    }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
      type: "submit",
      icon: "floppy-disk",
      intent: "primary",
      disabled: invalid || form.submitting
    }, translate("ScheduleFormBody.saveButton.text", "Create Schedule")), /*#__PURE__*/_react["default"].createElement(_core.Button, {
      className: "bp6-button",
      onClick: this.confirmNavigate
    }, translate("ScheduleFormBody.cancelButton.text", "Cancel")))))), selectedTabId === "details" && /*#__PURE__*/_react["default"].createElement(_Core.Content, null, /*#__PURE__*/_react["default"].createElement("h2", null, translate("ScheduleFormBody.scheduleDetails", "Schedule Details")), /*#__PURE__*/_react["default"].createElement(_ScheduleNameField.ScheduleNameField, null), /*#__PURE__*/_react["default"].createElement(_ScheduleStartTimeField.ScheduleStartTimeField, null), /*#__PURE__*/_react["default"].createElement(_ScheduleWorkdayOffsetField.ScheduleWorkdayOffsetField, null)), selectedTabId === "agendas" && /*#__PURE__*/_react["default"].createElement(_Core.Content, null, /*#__PURE__*/_react["default"].createElement(_ScheduleAgendasField.ScheduleAgendasField, {
      form: form,
      calendarConfig: Object.assign({}, calendarConfig, {
        schedules: [values]
      }),
      onCreateAgenda: this.handleCreateAgenda,
      onDeleteAgenda: this.handleDeleteAgenda,
      onCreateEventConfig: this.handleCreateEventConfig,
      onSelectAgenda: this.handleSelectAgenda,
      onSelectEventConfig: this.handleSelectEventConfig,
      selectedAgendaID: this.state.selectedAgendaID,
      selectedEventConfigID: this.state.selectedEventConfigID
    })));
  };
  return ScheduleFormBody;
}(_react.Component)) || _class;